import { render, staticRenderFns } from "./RatingDepartmentStat.vue?vue&type=template&id=c8edfee6"
import script from "./RatingDepartmentStat.vue?vue&type=script&lang=js"
export * from "./RatingDepartmentStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports